import React from 'react';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Skeleton, styled, Typography } from '@mui/material';

import { publicRoutes } from '../../../routes/appRouteList';
import { useAppSelector } from '../../../state/hooks';
import { ApiStatus } from '../../../utils/enums';
import DetailHeader from './DetailHeader';

const classesPrefix = 'areaDetailsHeader';

const classes = {
    loading: `${classesPrefix}-loading`,
};

const StyledSkeleton = styled(Skeleton)(({ theme }) => {
    return {
        [`&.${classes.loading}`]: {
            backgroundColor: theme.palette.grey[100],
        },
    };
});

const AreaBalanceHeader = (): React.JSX.Element => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams<{ name: string; }>();

    const areaBalanceDetailsApiStatus = useAppSelector((state) => { return state.areaBalance.areaBalanceDetailsApiStatus; });
    const areaBalanceDetails = useAppSelector((state) => { return state.areaBalance.areaBalanceDetails; });

    if (areaBalanceDetailsApiStatus === ApiStatus.Failure) {
        return (
            <Navigate
                to={`${publicRoutes.notFound}?requestedroute=${encodeURIComponent(`${location.pathname}${location.search}`)}&reason=${encodeURIComponent(`We tried, but we couldn't find an area named ${params.name}.`)}`}
            />
        );
    }

    return (
        <DetailHeader
            onBackClicked={(): void => {
                navigate(-1);
            }}
        >
            <Typography variant='h6'>
                {
                    areaBalanceDetailsApiStatus === ApiStatus.Loading ?
                        <StyledSkeleton className={classes.loading} width={150} />
                        :
                        areaBalanceDetails.service_area_name || areaBalanceDetails.service_area_id || params.name
                }
            </Typography>
        </DetailHeader>
    );
};

export default AreaBalanceHeader;
